// ** Axios Imports
import axios from "axios";
import moment from "moment";
import "moment/locale/ar";
import "moment/locale/en-au";
// ** Constants Imports
import { GOOGLE_MAP_GET_INFO_URL } from "../constants/urls";
import { GOOGLE_MAPS_API_KEY } from "../constants/services";

// ** Cheack If User LoggedIn (Cookis,localStorage,...etc)
export function isUserLoggedIn() {
  return true;
}

// ** Get Toke From Store
export function getTokenFromStorage(callback) {
  const userToken = localStorage.getItem("secure")
    ? JSON.parse(localStorage.getItem("secure"))
    : false;
  if (userToken) {
    callback(userToken.access_token);
  } else {
    callback(false);
  }
}

// ** If User Already Show Onboarding Screen
export function IsShowOnboarding() {
  if (localStorage.getItem("Onboarding") === "show") {
    return true;
  }
  return false;
}

// ** get Default language
export function getDefaultLanguage() {
  const userLang =
    window.localStorage.getItem("lang") ||
    navigator.language ||
    navigator.userLanguage;
  let direction = userLang.includes("ar") ? "rtl" : "ltr";
  localStorage.setItem("lang", userLang.substr(0, 2));
  return { lang: userLang.substr(0, 2), direction };
}

// ** Get Client Location
export function getClientLocation() {
  const options = { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 };
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (positionCallback) => {
        resolve({
          data: positionCallback,
          currentPosition: {
            lat: positionCallback.coords.latitude,
            long: positionCallback.coords.longitude
          }
        });
      },
      (positionErrorCallback) => {
        reject({ error: positionErrorCallback });
      },
      options
    );
  });
}

// ** Helper Get Value From API Result Google Map
function resultMapGetItem(arr, inc) {
  const item = arr.find((el1) => el1?.types.includes(inc));
  return item;
}
// ** Get Client Info From Google Map API
export async function getInfoFromGoogleMap({ latlong, language }) {
  const url = `${GOOGLE_MAP_GET_INFO_URL}${latlong}&key=${GOOGLE_MAPS_API_KEY}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          "Accept-Language": language || "ar"
        }
      })
      .then(async (res) => {
        
        if (Array.isArray(res.data.results)) {
          const  results  = await res.data.results;
          const cityData = {city:null}
          const {address_components} = resultMapGetItem(results, "locality")
          const locality = resultMapGetItem(address_components,"locality")
          if(locality){
            cityData.city = locality;
          }
          const cleanData = {
            country: resultMapGetItem(results, "country") || "",
            plus_code: resultMapGetItem(results, "plus_code") || "",
            locality: resultMapGetItem(results, "locality") || "",
            route: resultMapGetItem(results, "route") || "",
            street_address: resultMapGetItem(results, "street_address") || "",
            administrative_area_level_1:
              resultMapGetItem(results, "administrative_area_level_1") || "",
            postal_code: resultMapGetItem(results, "postal_code") || "",
            cityInfo:cityData.city
          };
          resolve({
            status: true,
            data: results[0]?.formatted_address || false,
            allData: res.data.results,
            cleanData
          });
        }
        if (res.data.status === "OK" || res.data.status === 200 ) {
        } else {
          resolve({
            status: false,
            error: res.data?.error_message || "Opps Error!"
          });
        }
      })
      .catch((error) => reject({ error }));
  });
}

// ** Format Text
export const foramtTextAddress = (text) => {
  if (text) {
    const data = [];
    for (const key in text) {
      if (Object.hasOwnProperty.call(text, key)) {
        const element = text[key]?.formatted_address;
        if (element) {
          // data.push(`${t(key)} : ${element}`);
          data.push(`${element}`);
        }
      }
    }
    try {
      return data.join(" - ");
    } catch (error) {
      return "";
    }
  }
  return "";
};

// ** Payment Methods
export const listPaymentMethods = [
  {
    id: 1,
    label: "Visa Card",
    image: require("../assets/images/icons/payment/img-visa.svg").default
  },
  {
    id: 2,
    label: "Master Card",
    image: require("../assets/images/icons/payment/img-master.svg").default
  },
  {
    id: 3,
    label: "mada",
    image: require("../assets/images/icons/payment/img-mada.svg").default
  },
  {
    id: 4,
    label: "STC Pay",
    image: require("../assets/images/icons/payment/img-stc.svg").default
  }
];

// ** Percentage Progress Bar
export function percentageProgressbar({ starsCount, customerCount }) {
  var x = starsCount;
  var z = Math.floor(Math.fround(100 / (customerCount / x) / 5)); //Math.floor(x / customer * 100) //percentage formula
  return Number.isNaN(z) ? 0 : z;
}

// ** get Reating Values
export function getRatingValues(mealRates) {
  const data = {
    valueStars: {
      stars: 0,
      progress: 0,
      clientCount: 0
    }
  };
  //
  if (mealRates.length > 0) {
    const stars5 = mealRates.filter((el) => el.rate === 5);
    const stars4 = mealRates.filter((el) => el.rate === 4);
    const stars3 = mealRates.filter((el) => el.rate === 3);
    const stars2 = mealRates.filter((el) => el.rate === 2);
    const stars1 = mealRates.filter((el) => el.rate === 1);
    const total = mealRates.reduce((accumulator, currnt) => {
      return accumulator + currnt?.rate;
    }, 0);
    const tottle5Stars =
      stars5.length > 0
        ? stars5.reduce((accumulator, currnt) => {
            return accumulator + currnt?.rate;
          }, 0)
        : 0;
    const tottle4Stars =
      stars4.length > 0
        ? stars4.reduce((accumulator, currnt) => {
            return accumulator + currnt?.rate;
          }, 0)
        : 0;
    const tottle3Stars =
      stars3.length > 0
        ? stars3.reduce((accumulator, currnt) => {
            return accumulator + currnt?.rate;
          }, 0)
        : 0;
    const tottle2Stars =
      stars2.length > 0
        ? stars2.reduce((accumulator, currnt) => {
            return accumulator + currnt?.rate;
          }, 0)
        : 0;
    const tottle1Stars =
      stars1.length > 0
        ? stars1.reduce((accumulator, currnt) => {
            return accumulator + currnt?.rate;
          }, 0)
        : 0;

    // ** Current
    data.valueStars = {
      stars:
        (5 * tottle5Stars +
          4 * tottle4Stars +
          3 * tottle3Stars +
          2 * tottle2Stars +
          1 * tottle1Stars) /
        total,
      progress: 0,
      clientCount: mealRates?.length
    };

    // **
    data.progress = [
      {
        label: "5",
        value: percentageProgressbar({
          starsCount: tottle5Stars,
          customerCount: stars5.length
        })
      },
      {
        label: "4",
        value: percentageProgressbar({
          starsCount: tottle4Stars,
          customerCount: stars4.length
        })
      },
      {
        label: "3",
        value: percentageProgressbar({
          starsCount: tottle3Stars,
          customerCount: stars3.length
        })
      },
      {
        label: "2",
        value: percentageProgressbar({
          starsCount: tottle2Stars,
          customerCount: stars2.length
        })
      },
      {
        label: "1",
        value: percentageProgressbar({
          starsCount: tottle1Stars,
          customerCount: stars1.length
        })
      }
    ];
  }

  return data;
}

// ** Get Meal is Vegetarian
export function isVegetarian(isVegetarianObj) {
  if (isVegetarianObj) {
    const listFalse = ["0", 0, false, "false"];
    if (listFalse.includes(isVegetarianObj)) {
      return false;
    } else {
      return true;
    }
  }
}

// ** Convert date to 24 hours
export function dateToTime24(time) {
  return moment(time).format("HH:mm:ss");
}

export function time24To12(date) {
  if (date) {
    const lang = window.localStorage.getItem("lang") || "en";
    const timeTo = moment(new Date(`${new Date().getFullYear()} ${date}`));
    timeTo.locale(lang);
    return timeTo.format("h:mm:ss a");
  }
  return "00:00:00";
}
export function time24To12Now(add = 0) {
  const date = new Date();

  if (date) {
    const lang = window.localStorage.getItem("lang") || "en";
    const timeTo = moment(new Date(`${date}`));
    timeTo.locale(lang);
    if (add) {
      return timeTo.add(add, "hour").format("h:mm:ss a");
    }
    return timeTo.format("h:mm:ss a");
  }
  return "00:00:00";
}

export function getDayName({ date = new Date(), locale = "en-US" }) {
  return date.toLocaleDateString(locale, { weekday: "long" });
}

export function providerOpenCloseTime(timeWork = []) {
  const lang = localStorage.getItem("lang") || "ar";
  const day = getDayName({ date: new Date(), locale: lang });

  const getTimeWork = timeWork.find((el) => el.day === day);

  const provideTimeWork = {
    from: time24To12Now(),
    to: time24To12Now(5),
    isOpen: false
  };
  if (getTimeWork) {
    if (day === getTimeWork?.day) {
      const provideTimeWork = {
        from: time24To12Now(),
        to: time24To12Now(5),
        isOpen: true
      };
      return provideTimeWork;
    } else {
      return provideTimeWork;
    }
  }
  return provideTimeWork;
}
